import { useCallback } from "react";
import { ErrorState } from "@common/index";
import { useProductApi } from "@/hooks/apiHooks/useProductApi";
import { useListRead } from "./hooks/useListRead";
import { ProductGrid } from "./components/ProductGrid";

// GET /products/popular caps `limit` at 100 (ApplicationConstant.PopularListing
// .MaxLimit) and has no paging, so this page is the API's ceiling in one grid.
const POPULAR_PAGE_LIMIT = 100;

// /c/browse/popular (#401 B2): the "Most Popular → View all" page.
export const BrowsePopular = () => {
    const { getPopular } = useProductApi();
    // The page renders its own failed state, so the read's toast is
    // suppressed — as BrowseFeatured's is — rather than doubling up.
    const read = useCallback(
        () => getPopular(POPULAR_PAGE_LIMIT, { skipErrorNotification: true }),
        [getPopular],
    );
    const { items, status, retry } = useListRead(read);

    return (
        <div data-testid="browse-popular" className="bg-base-100">
            <div className="max-w-7xl mx-auto px-2 md:px-4 py-6 md:py-8">
                <h1 className="text-2xl md:text-3xl font-bold text-neutral px-2">
                    Most Popular
                </h1>
                {status === "failed" ? (
                    <ErrorState
                        message="Couldn't load popular products."
                        onRetry={retry}
                    />
                ) : (
                    <ProductGrid
                        products={items}
                        pageNumber={1}
                        totalPages={1}
                        isLoading={status === "loading"}
                    />
                )}
            </div>
        </div>
    );
};
